import { lazy } from "react";
import Loadable from "../../components/Loadable";
import {PROJECTMANAGMENT} from "../../utils/constant";
import {CLIENTMANAGMENT} from "../../utils/constant";



const ProjectManagment = Loadable(lazy(() => import("./ProjectManagment")));
const ClientManagment = Loadable(lazy(() => import("./ClientManagment")));
const ClientAmcManagement = Loadable(lazy(() => import("./ClientAmcManagement")));
const Quotation= Loadable(lazy(() => import("./quotation")));
const AddQuotation=Loadable(lazy(()=>import("./AddQuotation")))
const Invoice= Loadable(lazy(() => import("./Invoice")))
const AddInvoice=Loadable(lazy(()=>import("./AddInvoice")))
const projectRoute = [
  
  {
    path :"/projectmanagment/manage",
    element : <ProjectManagment/>,
    permission: PROJECTMANAGMENT,
  },
  {
    path :"/projectmanagment/client",
    element : <ClientManagment/>,
    permission: CLIENTMANAGMENT,
  },
  {
    path :"/projectmanagment/amc",
    element : <ClientAmcManagement />,
    permission: CLIENTMANAGMENT,
  },
  {
    path :"/projectmanagment/quotation",
    element : <Quotation/>,
    permission: PROJECTMANAGMENT,
  },

{
  path: "/projectmanagment/quotation/add",
  element: <AddQuotation />,
  permission: PROJECTMANAGMENT,
},
 {
    path :"/projectmanagment/invoice",
    element : <Invoice/>,
    permission: PROJECTMANAGMENT,
  },

{
  path: "/projectmanagment/invoice/add",
  element: <AddInvoice/>,
  permission: PROJECTMANAGMENT,
},
{
  path: "/projectmanagment/add-invoice",
  element: <AddInvoice/>,
  permission: PROJECTMANAGMENT,
},

];

export default projectRoute;